/**
 * @generated SignedSource<<b5ade07ca29842d1317a56b851a87e75>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Anthropic" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type UpdateAccountGroupInput = {
  description?: string | null | undefined;
  dynamicFilter?: string | null | undefined;
  name?: string | null | undefined;
  priority?: number | null | undefined;
  regions?: ReadonlyArray<string> | null | undefined;
  shortName?: string | null | undefined;
  uuid: string;
  variables?: string | null | undefined;
};
export type UpdateAccountGroupMutation$variables = {
  input: UpdateAccountGroupInput;
};
export type UpdateAccountGroupMutation$data = {
  readonly updateAccountGroup: {
    readonly group: {
      readonly accountMappings: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly account: {
              readonly id: string;
              readonly key: string;
              readonly name: string;
              readonly provider: CloudProvider;
            };
          };
        }>;
      };
      readonly description: string | null | undefined;
      readonly dynamicFilter: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly regions: ReadonlyArray<string> | null | undefined;
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
};
export type UpdateAccountGroupMutation = {
  response: UpdateAccountGroupMutation$data;
  variables: UpdateAccountGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Account",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dynamicFilter",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regions",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateAccountGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AccountGroupPayload",
        "kind": "LinkedField",
        "name": "updateAccountGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroupMappingConnection",
                "kind": "LinkedField",
                "name": "accountMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountGroupMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountGroupMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateAccountGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AccountGroupPayload",
        "kind": "LinkedField",
        "name": "updateAccountGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroupMappingConnection",
                "kind": "LinkedField",
                "name": "accountMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountGroupMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountGroupMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37ab8c1990c80fc6f7ace229268a87a5",
    "id": null,
    "metadata": {},
    "name": "UpdateAccountGroupMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateAccountGroupMutation(\n  $input: UpdateAccountGroupInput!\n) {\n  updateAccountGroup(input: $input) {\n    group {\n      accountMappings {\n        edges {\n          node {\n            account {\n              id\n              key\n              name\n              provider\n            }\n            id\n          }\n        }\n      }\n      description\n      dynamicFilter\n      id\n      name\n      regions\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea86c906a0f02d89a0e01a9e3162853a";

export default node;
